var _g, _g2, _g3, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.492,
    cy: 51.539,
    r: 30,
    fill: "#E6368B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.753 68.647c.325-.178.655-.349.985-.52.73-.38 1.463-.76 2.146-1.21 3.254-2.161 6.065-4.778 8.16-8.093 1.075-1.704 1.85-3.53 2.113-5.539.595-4.575-2.485-8.048-6.494-8.485-.237-.026-.263-.127-.263-.323l.003-.885c.005-.886.01-1.774-.028-2.658-.148-3.467-2.94-6.261-6.424-6.49-3.522-.228-6.666 2.206-7.275 5.634a8.28 8.28 0 0 0-.096 1.128c-.013.533.333.894.82.913.506.019.87-.336.89-.88.064-1.718.75-3.138 2.178-4.133 1.69-1.172 3.522-1.318 5.36-.4 1.831.913 2.766 2.466 2.837 4.488.026.808.02 1.616.012 2.435-.003.375-.006.752-.006 1.133-2.075.26-3.797 1.16-5.162 2.712-.137-.123-.27-.248-.401-.371a12.064 12.064 0 0 0-.815-.719c-3.138-2.459-7.743-2.224-10.465.545-1.485 1.508-2.132 3.34-2.081 5.431.051 2.098.762 4.005 1.793 5.812 1.69 2.965 4.048 5.348 6.724 7.446 1.288 1.008 2.639 1.933 4.125 2.649.181.088.368.163.555.239.11.044.22.088.328.135.167.006.32.006.48.006Zm-.256-16.667a1.98 1.98 0 0 0-1.992 1.97c0 .654.32 1.224.807 1.585l-.628 4.443h3.631l-.634-4.45c.487-.354.807-.93.807-1.577 0-1.09-.89-1.971-1.991-1.971Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75.492,
    cy: 71.539,
    r: 10,
    fill: "#22EC36"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.492,
    cy: 71.539,
    r: 9.5,
    stroke: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m73.992 74.164-2.625-2.625-.875.875 3.5 3.5 7.5-7.5-.875-.875-6.625 6.625Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0.492,
    y: 0.539,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1063_15751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1063_15751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 40.492,
    y: 40.539,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1063_15751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1063_15751",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 69.234 34.432)",
    d: "M0 0h27.48v34.215H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.0096f253b3785a1536801a5bd16cb379.svg";
export { ForwardRef as ReactComponent };